import ConveniencesServices from './ConveniencesServices.container';

export default ConveniencesServices;
